import React, { useState } from 'react';
import Widget from '../Widget';
import WidgetTitle from '../WidgetTitle';
import { Row } from 'react-bootstrap';

export default function HistoricalClassifications(props) {
    const history = JSON.parse(props.institutionData.post_meta.history.value)?.reverse();
    if (!history) return null;
    
    return (
        <Widget className="historical-classifications">
            <Row>
                <WidgetTitle>Historical Classifications</WidgetTitle>

                <div className='history-list'>
                    {history.map((item, i) => {
                        return (
                            <div key={i}>
                                <div className="d-flex">
                                    <div className="" style={{ fontSize: "14px", width: "50px", paddingTop: "2px", textAlign: "center" }}>{item.year}</div>
                                    <div className="fw-semibold" style={{ fontSize: "16px", maxWidth: "500px" }}>{item.classification}</div>
                                </div>
                                {i < history.length - 1 && <div style={{ color: "#d7d7d7", width: "50px", textAlign: "center" }}>|</div>}
                            </div>
                        )
                    })}
                </div>
            </Row>
        </Widget >
    );
}